import { updateDoctorProfile } from "../../../Common/axios_instance/auth_https/auth.https";
import { uploadProfilePicture } from "../../../Common/axios_instance/azure_https/azure.https";

export const uploadAndSaveProfilePicture = async (
  file: File,
  doctorId: string,
  refreshDoctorProfile: () => Promise<void>
): Promise<void> => {
  const uploadRes = await uploadProfilePicture(file);
  const s3Url = uploadRes.data?.data?.url;
  if (!s3Url) throw new Error("No URL returned from upload");
  await updateDoctorProfile(doctorId, { profilePhoto: s3Url });
  await refreshDoctorProfile();
};
